import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { NotificationType } from 'src/app/enum/notification-type.enum';
import { Buttons } from 'src/app/home/table/Buttons';
import { TableColumn } from 'src/app/home/table/TableColumn';
import { KomFeed } from 'src/app/models/commission/kom-feed.model';
import { CustomHttpRespone } from 'src/app/models/customhttpresponse/custom-http-response';
import { UserManagementModel } from 'src/app/models/userManagementModel/usermang.model';
import { CommissionService } from 'src/app/service/commission.service';
import { ExportExcelService } from 'src/app/service/export-excel.service';
import { GlobalService } from 'src/app/service/global.service';
import { KomFeedService } from 'src/app/service/komfeed.service';
import { NotificationService } from 'src/app/service/notification.service';

@Component({
  selector: 'app-kom-feed-result',
  templateUrl: './kom-feed-result.component.html',
  styleUrls: ['./kom-feed-result.component.css']
})
export class KomFeedResultComponent implements OnInit {
  feedResultsData: KomFeed[] = [];
  feedResultsDataExcel: KomFeed[] = [];
  feedResultsRepData: KomFeed[] = [];
  rateCodeData: KomFeed[] = [];
  reportingCentersData: KomFeed[] = [];
  columnsData: any;
  dataForExcel = [];
  columnsExcelData: any;
  ordersTableExcelHeaderColumns: TableColumn[];
  ordersTableColumns: TableColumn[];
  ordersTableColumns2: TableColumn[];
  resHeadder: string = 'KOM Feed Results';
  actions: any;
  actionButtons: any;
  buttons: Buttons[] = [];
  komfeedModel = new KomFeed();
  komfeedModel1 = new KomFeed();
  IsmodelShow: boolean = false;
  exportExcelUserData: KomFeed[] = [];
  isAccessDisabled: boolean = false;

  menusFilter: UserManagementModel[] = [];
  isView: boolean = true;
  permissionCheck: any;
  errorMessage: string;
  delcodeid: string;
  addcodeid: string;
  currproclassid: string;
  prevproclassid: string;
  orderdt: Date;

  showVal1: boolean;
  showVal2: boolean;
  showVal3: boolean;
  showVal4: boolean;
  showVal5: boolean;
  showVal6: boolean;
  showVal7: boolean;
  showVal8: boolean;
  showVal9: boolean;
  showVal10: boolean;

  showVal11: boolean;
  showVal12: boolean;
  showVal13: boolean;
  showVal14: boolean;
  showVal15: boolean;
  showVal16: boolean;
  showVal17: boolean;
  showVal18: boolean;
  showVal19: boolean;
  showVal20: boolean;


  public rctr01: string;
  public rctr02: string;
  public rctr03: string;
  public rctr04: string;
  public rctr05: string;
  public rctr06: string;
  public rctr07: string;
  public rctr08: string;
  public rctr09: string;
  public rctr10: string;

  public rctr11: string;
  public rctr12: string;
  public rctr13: string;
  public rctr14: string;
  public rctr15: string;
  public rctr16: string;
  public rctr17: string;
  public rctr18: string;
  public rctr19: string;
  public rctr20: string;

  public rc01: string;
  public rc02: string;
  public rc03: string;
  public rc04: string;
  public rc05: string;
  public rc06: string;
  public rc07: string;
  public rc08: string;
  public rc09: string;
  public rc10: string;

  public rc11: string;
  public rc12: string;
  public rc13: string;
  public rc14: string;
  public rc15: string;
  public rc16: string;
  public rc17: string;
  public rc18: string;
  public rc19: string;
  public rc20: string;

  constructor(private komFeedService: KomFeedService, private commissionService: CommissionService, private router: Router,
    private notificationService: NotificationService, private httpService: HttpClient,
    private exportExcelService: ExportExcelService, private globalService: GlobalService) { }

  ngOnInit(): void {
    this.init();
    this.isAccessDisabled = this.globalService._permissionCheck('comm-plan');
    if (this.isAccessDisabled)
      this.notificationService.notify(NotificationType.WARNING, "Edit Permission Has Disabled Please Contact To Adminstrator");
  }

  init() {
    this.getResults();
    this.getResultsExcel();
    this.initializeColumns();
    this.initializeExcelHeaders();
    this.checkPermission();
  }

  getResults() {
    this.komFeedService.getFeedSerchResults(this.commissionService.komFeedModel).subscribe((data: KomFeed[]) => {
      this.feedResultsData = data;
      console.log(this.feedResultsData);
    }, (errorResponse: HttpErrorResponse) => {
      var msg: any;
      msg = errorResponse;
      this.notificationService.sendNotification(NotificationType.ERROR, msg);
    });
  }

  getResultsExcel() {
    this.komFeedService.getFeedSerchResultsExcel(this.commissionService.komFeedModel).subscribe((data: KomFeed[]) => {
      this.feedResultsDataExcel = data;
      console.log(this.feedResultsDataExcel);
    }, (errorResponse: HttpErrorResponse) => {
      var msg: any;
      msg = errorResponse;
      this.notificationService.sendNotification(NotificationType.ERROR, msg);
    });
  }

  public checkPermission() {
    this.errorMessage = '';
    this.menusFilter = JSON.parse(localStorage.getItem('menulist'));
    console.log(this.menusFilter);
    this.menusFilter = this.menusFilter.filter(val => this._normalizeValue(val.nav_page_name).includes(this._normalizeValue('Feed Adjustments')));
    this.permissionCheck = this.menusFilter[0].edit_acc;
    if (this.permissionCheck === "y") {
      this.isAccessDisabled = false;
    } else {
      this.isAccessDisabled = true;
    }
    console.log(this.permissionCheck);
    console.log(this.isAccessDisabled);
  }

  private _normalizeValue(value: string): string {
    return value.toLowerCase().replace(/\s/g, '');
  }



  initializeExcelHeaders(): void {
    this.httpService.get('../../../assets/json/excelHeaders.json').subscribe(
      data => {
        this.columnsExcelData = data;
        this.ordersTableExcelHeaderColumns = this.columnsExcelData.FeedResults;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );
  }

  exportExcel() {

    this.exportExcelUserData = JSON.parse(JSON.stringify(this.feedResultsDataExcel));
    console.log(this.exportExcelUserData);
    for (let js of this.exportExcelUserData) {
      delete js.curr_Integerl_combo_str;
      delete js.integerernal_net_ool;
      delete js.integerernal_net_ov;
      delete js.prev_Integerl_combo_str;
      delete js.wipBuyInfoModel;
      delete js.id;
      delete js.adjustmentFeed;
      delete js.orderFromDate;
      delete js.orderToDate;
      delete js.tech;
      delete js.sales_addition_code;
      delete js.addition_code_id;
      delete js.deletion_code_id;
      delete js.curr_product_class_id;
      delete js.prev_product_class_id;
      delete js.curr_mdm_tier_rpt;
      delete js.prev_mdm_tier_rpt;
      delete js.prem_upgr_downgr_flag;
      delete js.net_rev_change;
      delete js.recurring_rev;
      delete js.video_add_flag;
      delete js.ool_add_flag;
      delete js.restel_add_flag;
      delete js.io_add_flag;
      delete js.ov_add_flag;
      delete js.comm_year;
      delete js.promo_amt;
      delete js.internal_net_ool;
      delete js.vr_unit_revenue;
      delete js.pia_revenue;
      delete js.sip_add_revenue;
      delete js.sip_remove_revenue;
      delete js.vow_unit;
      delete js.vow_unit_revenue;
      delete js.svod_revenue_change;
      delete js.misc_video_revenue_change;
      delete js.total_dvr_revenue_change;
      delete js.dvr_revenue_change;
      delete js.curr_chrg_buffers;
      delete js.curr_nonchrg_buffers;
      delete js.prev_chrg_buffers;
      delete js.prev_nonchrg_buffers;
      delete js.ool_revenue_change;
      delete js.iptel_revenue_change;
      delete js.analog_revenue_change;
      delete js.io_revenue_change;
      delete js.curr_addl_did_blocks;
      delete js.prev_addl_did_blocks;
      delete js.m2m_revenue_change;
      delete js.install_revenue;
      delete js.mdu_flag;
      delete js.auto_ind;
      delete js.auto_pay;
      delete js.account_id;
      delete js.prev_non_ported_lines;
      delete js.curr_non_ported_lines;
      delete js.prev_tf_lines;
      delete js.curr_tf_lines;
      delete js.dvr_plus_add_flag;
      delete js.dvr_plus_free_flag;
      delete js.dvr_plus_remove_flag;
      delete js.dvr_plus_unit_revenue;
      delete js.dvr_unit_revenue;
      delete js.free_dvr_unit;
      delete js.dvr_plus_unit;
      delete js.exclude_from_yield;
      delete js.net_ov;
      delete js.internal_net_ov;
      delete js.zip_blitz;
      delete js.dvr_unit;
      delete js.dvr_revenue;
      delete js.prev_new_video_offer_id;
      delete js.curr_new_video_offer_id;
      delete js.net_rev_change_a;
      delete js.net_rev_change_o;
      delete js.net_rev_change_d;
      delete js.net_rev_change_ov;
      delete js.net_rev_change_restel;
      delete js.net_prem_chanels;
      delete js.net_svod;
      delete js.net_sports;
      delete js.net_converters;
      delete js.net_restel;
      delete js.net_ool;
      delete js.pr_status_id;
      delete js.last_modified_by;
      delete js.employee_pay_id;
      delete js.flat_rate_ncr;
      delete js.who;
      delete js.cust_type;
      delete js.revenue_upgr_downgr_flag;
      delete js.io_upgr_downgr_flag;
      delete js.winback_flag;
      delete js.comm_month;
      delete js.wcampg;
      delete js.prev_sports_combo_str;
      delete js.curr_sports_combo_str;
      delete js.prev_svod_combo_str;
      delete js.curr_svod_combo_str;
      delete js.prev_intl_combo_str;
      delete js.curr_intl_combo_str;
      delete js.prev_io_combo_str;
      delete js.curr_io_combo_str;
      delete js.prev_ool_combo_str;
      delete js.curr_ool_combo_str;
      delete js.prev_ov_combo_str;
      delete js.curr_ov_combo_str;
      delete js.prev_misc_combo_str;
      delete js.curr_misc_combo_str;
      delete js.drsn;
      delete js.drsn_remove_chgbk;
      delete js.m2m_speed;
      delete js.add_svod_combo_str;
      delete js.del_svod_combo_str;
      delete js.customer_type;
      delete js.created_by;
      delete js.updated_by;
      delete js.feed_dt;
      delete js.last_modified_on;
      delete js.ordertime;
      delete js.begin_date;
      delete js.created_dt;
      delete js.updated_dt;

      delete js.wipBuyInfo;
      delete js.wibBuyInfoID;
      delete js.svcsType;

      // delete js.serty_id;
      // delete js.ratecd;
      // delete js.ratesign;
      // delete js.sercnt;
      // delete js.samt;
      // delete js.f_level;

      delete js.custname;
      delete js.kom_code;
      delete js.komfeedid;

      delete js.rc01;
      delete js.rc02;
      delete js.rc03;
      delete js.rc04;
      delete js.rc05;
      delete js.rc06;
      delete js.rc07;
      delete js.rc08;
      delete js.rc09;
      delete js.rc10;

      delete js.rc11;
      delete js.rc12;
      delete js.rc13;
      delete js.rc14;
      delete js.rc15;
      delete js.rc16;
      delete js.rc17;
      delete js.rc18;
      delete js.rc19;
      delete js.rc20;

      delete js.rctr01;
      delete js.rctr02;
      delete js.rctr03;
      delete js.rctr04;
      delete js.rctr05;
      delete js.rctr06;
      delete js.rctr07;
      delete js.rctr08;
      delete js.rctr09;
      delete js.rctr10;

      delete js.rctr11;
      delete js.rctr12;
      delete js.rctr13;
      delete js.rctr14;
      delete js.rctr15;
      delete js.rctr16;
      delete js.rctr17;
      delete js.rctr18;
      delete js.rctr19;
      delete js.rctr20;

      delete js.wddate;
      delete js.wfindate;
      delete js.wordate;
      delete js.curr_prem_combo_str;
      delete js.descrip1;
      delete js.descrip2;

      delete js.flag1;
      delete js.flag2;
      delete js.flag3;
      delete js.flag4;
      delete js.flag5;
      delete js.flag6;
      delete js.flag7;
      delete js.flag8;

      delete js.free_dvr_unit_revenue;
      delete js.prev_prem_combo_str;
      delete js.productName;
      delete js.rdesc;
      delete js.sip_acq;
      delete js.sip_add_units;
      delete js.sip_conv_unit;
      delete js.sip_remove_units;

      delete js.status;
      delete js.trunk_units;
      delete js.vr_unit;

    }
    //console.log(this.exportExcelUserData);
    this.dataForExcel = [];
    let reportData = null;
    this.exportExcelUserData.forEach((row: any) => {
      this.dataForExcel.push(Object.values(row))
    })
    reportData = {
      title: 'KomFeed Data',
      data: this.dataForExcel,
      headers: Object.keys(this.ordersTableExcelHeaderColumns[0])
    }
    this.exportExcelService.exportExcel(reportData);
  }



  public deleteRowByWipByinfoId(id: number): void {
    if (confirm("Are you sure to delete this Record")) {
      this.komFeedService.deleteRowByWipByinfoId(id).subscribe(
        (response: CustomHttpRespone) => {
          this.notificationService.sendNotification(NotificationType.SUCCESS, response.message);
          this.init();
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      )
    }
  }

  redirect(url: string) {
    this.router.navigate(['/' + url]);
  }

  actionOnButton(action: any) {
    console.log(action);
    if (action === "Add New" && !this.isAccessDisabled) {
      this.IsmodelShow = false;;
      document.getElementById(action).click();
    } else {
      this.errorMessage = 'Edit Permission has Disabled Please Contact Admin';
    }
  }

  getKomFeedDataById(id: any, status: string) {
    console.log("getKomFeedDataById() called");
    console.log(id);
    this.komFeedService.getKomFeedDataById(id).subscribe
      ((data: KomFeed) => {
       // console.log(JSON.stringify(data));
        this.commissionService.editKomFeedModel = data;

        if(this.commissionService.editKomFeedModel.si_activation_date){
          const dt = new Date(this.commissionService.editKomFeedModel.si_activation_date).toISOString().split('T')[0];
          this.commissionService.editKomFeedModel.si_activation_date = dt;
        }

        if(this.commissionService.editKomFeedModel.wfindate){
          const dt = new Date(this.commissionService.editKomFeedModel.wfindate).toISOString().split('T')[0];
          this.commissionService.editKomFeedModel.wfindate = dt;
        }

        if(this.commissionService.editKomFeedModel.lead_assigned_date){
          const dt = new Date(this.commissionService.editKomFeedModel.lead_assigned_date).toISOString().split('T')[0];
          this.commissionService.editKomFeedModel.lead_assigned_date = dt;
        }
        

        this.commissionService.editKomFeedModel.status = status;
       // console.log(this.commissionService.editKomFeedModel);
        this.router.navigate(['/edit-komFeed']);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  getKomFeedDataByCorpHouseRep(corp: number, house: string, salesrepid: string, status: string) {
    // console.log(status);
    this.komFeedService.getKomFeedDataByCorpHouseRep(corp, house, salesrepid).subscribe
      ((data: KomFeed) => {
        //console.log(JSON.stringify(data));
        this.commissionService.editKomFeedModel = data;
        this.commissionService.editKomFeedModel.status = status;
        //console.log(this.commissionService.editKomFeedModel);
        this.router.navigate(['/edit-komFeed']);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  getKomFeedDataByRepId(corp: number, house: string, salesrepid: string, id: number) {
    //console.log(status);
    this.komFeedService.getKomFeedDataByRepId(corp, house, salesrepid, id).subscribe
      ((data: KomFeed[]) => {
        this.feedResultsRepData = data;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  update(row: any, values: any) {
    // console.log(row);
    //console.log(values);
    //console.log(values.value);
  }

  openPopup(row: any) {
    //console.log(row);
    // console.log(row.row.corp);
    // console.log(row.row.ratecd);
    this.getRateCodeInfo(row.row.corp, row.row.ratecd);
    this.getReportingCentersInfo(row.row.corp, row.row.ratecd);
    document.getElementById('showratecodeinfo').click();
  }

  getRateCodeInfo(corp: number, ratecd: string) {
    //console.log(status);
    this.komFeedService.getRateCodeInfo(corp, ratecd, this.orderdt).subscribe
      ((data: KomFeed[]) => {
        this.rateCodeData = data;
        // console.log(this.rateCodeData);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  getReportingCentersInfo(corp: number, ratecd: string) {
    //console.log(status);
    this.komFeedService.getReportingCentersInfo(corp, ratecd, this.orderdt).subscribe
      ((data: KomFeed[]) => {
        this.reportingCentersData = data;
        console.log(this.reportingCentersData);

        for (let rc of this.reportingCentersData) {


          this.rctr01 = rc.rctr01;
          this.rc01 = rc.rc01;

          if (this.rctr01) {
            this.showVal1 = true;
          } else {
            this.showVal1 = false;
          }

          this.rctr02 = rc.rctr02;
          this.rc02 = rc.rc02;

          if (this.rctr02) {
            this.showVal2 = true;
          } else {
            this.showVal2 = false;
          }

          this.rctr03 = rc.rctr03;
          this.rc03 = rc.rc03;

          if (this.rctr03) {
            this.showVal3 = true;
          } else {
            this.showVal3 = false;
          }

          this.rctr04 = rc.rctr04;
          this.rc04 = rc.rc04;

          if (this.rctr04) {
            this.showVal4 = true;
          } else {
            this.showVal4 = false;
          }

          this.rctr05 = rc.rctr05;
          this.rc05 = rc.rc05;

          if (this.rctr05) {
            this.showVal5 = true;
          } else {
            this.showVal5 = false;
          }

          this.rctr06 = rc.rctr06;
          this.rc06 = rc.rc06;

          if (this.rctr06) {
            this.showVal6 = true;
          } else {
            this.showVal6 = false;
          }

          this.rctr07 = rc.rctr07;
          this.rc07 = rc.rc07;

          if (this.rctr07) {
            this.showVal7 = true;
          } else {
            this.showVal7 = false;
          }

          this.rctr08 = rc.rctr08;
          this.rc08 = rc.rc08;

          if (this.rctr08) {
            this.showVal8 = true;
          } else {
            this.showVal8 = false;
          }

          this.rctr09 = rc.rctr09;
          this.rc09 = rc.rc09;

          if (this.rctr09) {
            this.showVal9 = true;
          } else {
            this.showVal9 = false;
          }

          this.rctr10 = rc.rctr10;
          this.rc10 = rc.rc10;

          if (this.rctr10) {
            this.showVal10 = true;
          } else {
            this.showVal10 = false;
          }

          this.rctr11 = rc.rctr11;
          this.rc11 = rc.rc11;

          if (this.rctr11) {
            this.showVal11 = true;
          } else {
            this.showVal11 = false;
          }

          this.rctr12 = rc.rctr12;
          this.rc12 = rc.rc12;

          if (this.rctr12) {
            this.showVal12 = true;
          } else {
            this.showVal12 = false;
          }

          this.rctr13 = rc.rctr13;
          this.rc13 = rc.rc13;

          if (this.rctr13) {
            this.showVal13 = true;
          } else {
            this.showVal13 = false;
          }

          this.rctr14 = rc.rctr14;
          this.rc14 = rc.rc14;

          if (this.rctr14) {
            this.showVal14 = true;
          } else {
            this.showVal14 = false;
          }

          this.rctr15 = rc.rctr15;
          this.rc15 = rc.rc15;

          if (this.rctr15) {
            this.showVal15 = true;
          } else {
            this.showVal15 = false;
          }

          this.rctr16 = rc.rctr16;
          this.rc16 = rc.rc16;

          if (this.rctr16) {
            this.showVal16 = true;
          } else {
            this.showVal16 = false;
          }

          this.rctr17 = rc.rctr17;
          this.rc17 = rc.rc17;

          if (this.rctr17) {
            this.showVal17 = true;
          } else {
            this.showVal17 = false;
          }

          this.rctr18 = rc.rctr18;
          this.rc18 = rc.rc18;

          if (this.rctr18) {
            this.showVal18 = true;
          } else {
            this.showVal18 = false;
          }

          this.rctr19 = rc.rctr19;
          this.rc19 = rc.rc19;

          if (this.rctr19) {
            this.showVal19 = true;
          } else {
            this.showVal19 = false;
          }

          this.rctr20 = rc.rctr20;
          this.rc20 = rc.rc20;

          if (this.rctr20) {
            this.showVal20 = true;
          } else {
            this.showVal20 = false;
          }
        }
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }


  close(form: NgForm, id: string) {
    console.log('======', id);
    form.reset();
    document.getElementById(id).click();
  }

  public saveNewRecord(kpiForm: NgForm): void {
    // console.log("======= ", this.feedResultsData[0].wibBuyInfoID);
    // this.komfeedModel.wibBuyInfoID = this.feedResultsData[0].wibBuyInfoID;
    this.komfeedModel.id = this.komfeedModel1.id;
    console.log("======= ", this.komfeedModel);

    this.komFeedService.saveWibByInfoData(this.komfeedModel).subscribe((data: KomFeed) => {
      this.notificationService.sendNotification(NotificationType.SUCCESS, 'Inserted Successfully');
      this.close(kpiForm, 'closeAddKPIButton');
      this.init()
    }, (errorResponse: HttpErrorResponse) => {
      var msg: any;
      msg = errorResponse;
      this.notificationService.sendNotification(NotificationType.ERROR, msg);
    });

  }

  onAddRecord(komFeed: KomFeed) {
    this.komfeedModel1 = komFeed;
    //console.log(this.komfeedModel1.id);
    document.getElementById("Add New").click();
  }

  innerRowAction1(row: any) {
    //console.log(row);
    console.log(row.row.id);
    if (row.value === 'View') {
      this.orderdt = row.row.wordate;
      this.getKomFeedDataByRepId(row.row.corp, row.row.house, row.row.sales_rep_id, row.row.id);
    }
    if (!this.isAccessDisabled) {
      // if (row.value === 'Delete') {
      //   this.deleteRowByWipByinfoId(row.row.wibBuyInfoID);
      // } else 
      if (row.value === 'Update') {
        // console.log(row.row);
        this.getKomFeedDataById(row.row.id, 'Update');
        //this.getKomFeedDataByCorpHouseRep(row.row.corp, row.row.house, row.row.sales_rep_id, 'Update');
      } else if (row.value === 'Replicate') {
        this.getKomFeedDataById(row.row.id, 'Replicate');
      } else if (row.value === 'Add') {
        console.log("Inside Add");
        // this.getKomFeedDataById(row.row.id, 'Replicate');
        this.onAddRecord(row.row);
        //document.getElementById("Add New").click();
      }
    } else {
      this.errorMessage = 'Edit Permission has Disabled Please Contact Admin';
    }
  }

  innerRowAction2(row: any) {
    console.log("innerRowAction ....", row);
    console.log("innerRowAction ....", row.value);
    if (row.value === 'Delete') {
      this.deleteRowByWipByinfoId(row.row.wibBuyInfoID);
    }

  }

  initializeColumns(): void {
    this.httpService.get('../../../assets/json/tableColumns.json').subscribe(
      data => {
        this.columnsData = data;
        this.ordersTableColumns = this.columnsData.KomFeedResults;
        this.ordersTableColumns2 = this.columnsData.KomFeedRepResults;
        //console.log(this.ordersTableColumns);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    );
    this.actions = [
      {
        name: 'Add',
        dataKey: 'fa fa-plus success f-25',
        position: 'left',
        isSortable: false,
        class: 'badge bg-success'
      },
      {
        name: 'Delete',
        dataKey: 'far fa-trash-alt danger f-25',
        position: 'left',
        isSortable: false,
        class: 'badge bg-danger'
      },
      {
        name: 'Update',
        dataKey: 'far fa-edit success f-25',
        position: 'left',
        isSortable: false,
        class: 'badge bg-success'
      },
      {
        name: 'Replicate',
        dataKey: 'far fa-clone primary f-25',
        position: 'left',
        isSortable: false,
        class: 'badge bg-success'
      }
    ]

    this.actionButtons = [
      // {
      //   name: 'Add New',
      //   class: 'btn btn-success btn-xs'
      // }
    ]
    this.buttons = [

      {
        name: 'Back',
        pagenavigation: 'adjustments-feed'
      }
    ]
  }

}